import React from "react";
import {Link} from "react-router-dom";
import {Table} from "semantic-ui-react";


export default function InvoicesTable(props) {
    const {invoices} = props;

    const listInvoices = invoices.map((invoice) =>
        <Table.Row key={invoice.id}>
            <Table.Cell><Link to={`/invoices/${invoice.id}`}>{invoice.id}</Link></Table.Cell>
            <Table.Cell>{invoice.invoice_number}</Table.Cell>
            <Table.Cell>{invoice.date}</Table.Cell>
            <Table.Cell>{invoice.customer_name}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>NR</Table.HeaderCell>
                    <Table.HeaderCell>Datum</Table.HeaderCell>
                    <Table.HeaderCell>Kunde</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listInvoices}</Table.Body>
        </Table>
    )
}


